module.exports = __webpack_public_path__ + "static/media/banner-ensina-financas.c5eb395b.png";